module.exports = __webpack_public_path__ + "01428eee2757ad0a87d432165625ce03.png";